import {
  Empty_NoSqlDoc,
  FBDTKeygenGeneric,
  MakeFBDocType,
  NoSqlDoc,
} from '@rabbit/firebase/doctype';
import { TenantLink } from './tenant';
import { PersonaLink } from '../persona';

/* -------------------------------------------------------------------------- */
/*                                Main Groups                                 */
/* -------------------------------------------------------------------------- */

export interface AssociatedPartner {
  /** The link to the partner */
  tenantLink: TenantLink;

  /** The link to the business user invite */
  businessUserInviteLink: string;

  /** The name of the partner */
  name: string;
}

export interface AssociatedPartnerBrand {
  /** The link to the partner */
  tenantLink: TenantLink;

  /** The link to the business user invite */
  businessUserInviteLink: string;

  /** The brand of the partner */
  brand: string[];
}

/** A type representing a main group in the system */
export interface DTMainGroup extends NoSqlDoc {
  /** The name of the main group */
  title: string;

  /** shared location flag : using to get the partners and partners brands to show the vendable list and retailers list */
  sharedLocation: boolean;

  /** A description of the main group */
  description?: string;

  /** A link to the tenant that owns this main group */
  tenantLink?: TenantLink;

  /** A list of principals that have access to this main group */
  principals?: PersonaLink[];

  /** A list of dealers that have access to this main group */
  associatedPartners?: AssociatedPartner[];

  /** A list of brands that have access to this main group */
  associatedPartnerBrands?: AssociatedPartnerBrand[];
}

export const FBD_MainGroup = MakeFBDocType<DTMainGroup>({
  name: 'MainGroup',
  collection: 'main-group',
  empty: () => {
    const result: DTMainGroup = {
      ...Empty_NoSqlDoc(),
      title: '',
      sharedLocation: false,
      associatedPartners: [],
      associatedPartnerBrands: [],
    };
    return result;
  },
  keygen: FBDTKeygenGeneric,
});

export type MainGroupLink = string;
